const RECEIVABLES_SERIES = new Set([
  "received",
  "toReceive",
  "variation",
  "allBills",
  "allBillsAccumulated",
  "allBalance",
]);
const RECEIVABLE_EXPORT_KEYS = new Set([
  "variation",
  "allBalances",
  "received",
  "toReceive",
  "allBillsRaw",
]);

export const receivablesStateOrLegacy = (state) => state ?? "available";

export const filterReceivablesSeries = (series, state) => (
  receivablesStateOrLegacy(state) === "restricted"
    ? series.filter((key) => !RECEIVABLES_SERIES.has(key))
    : series
);

export const filterReceivablesExport = ({ fields, resources } = {}, state) => {
  if (receivablesStateOrLegacy(state) !== "restricted") return { fields, resources };
  const safeFields = Array.isArray(fields) ? fields : [];
  const safeResources = Array.isArray(resources) ? resources : [];
  const filteredFields = safeFields.filter(({ key }) => !RECEIVABLE_EXPORT_KEYS.has(key));
  const allowedKeys = new Set(filteredFields.map(({ key }) => key));
  return {
    fields: filteredFields,
    resources: safeResources.map((row) => Object.fromEntries(
      Object.entries(row).filter(([key]) => allowedKeys.has(key)),
    )),
  };
};
